import request from '../../http/request'

export const uploadSku = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/nsp/uploadSKUs`, params, {
    uploadSku: true
  })
}
export const getSkuList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/nsp/search`, { params })
}
export const getPFSkuList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/pf/search`, { params })
}
export const getRFIDSkuList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/rfid/search`, { params })
}

export const refreshNSPNFCSku = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/nsp/manuallyRetrieve`, params, {
    refreshCode: true
  })
}
export const refreshRFID = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-share-service/sku/rfid/manuallyRetrieve`, params, {
    refreshCode: true
  })
}
export const refreshPFNFCSku = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/pf/manuallyRetrieve`, params, {
    refreshCode: true
  })
}
// export const logSearch = params => {
//   return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/log/search`, params)
// }

export const getNSPUpdateTime = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/nsp/recently_updated_date`, { params })
}

export const getPFUpdateTime = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/pf/recently_updated_date`, { params })
}

export const getRFIDUpdateTime = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/rfid/last_updated_date`, { params })
}

export const getWaveRunUpdateTime = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/wave_run/recently_updated_date`, { params })
}
